export default "__VITE_ASSET__DL40Q0yi__"